export const GET_PATIENT_REQUEST = "GET_PATIENT_REQUEST";
export const GET_PATIENT_SUCCESS = "GET_PATIENT_SUCCESS";
export const GET_PATIENT_ERROR = "GET_PATIENT_ERROR";

export const CLEAR_PATIENT_FLAGS = "CLEAR_PATIENT_FLAGS";
